export default __webpack_public_path__ + "static/media/client5.30592ce4.png";